
import {ACTIONS} from "../actions";
import {HIGH_LEVEL_CONFIG} from "../../config/high_level_config";


const INITIAL_STATE = {
    language: HIGH_LEVEL_CONFIG.DEFAULT_LANGUAGE,
    menuColor: 'light'
};


const navigationReducer = (state: any = INITIAL_STATE, action: { type: string } | any) => {

    switch (action.type) {

        case ACTIONS.CHANGE_LANGUAGE:
            // update the language
            state = {...state, ...{language: action.language }};
            break;

        case ACTIONS.PAGES_MAPPING_LOADED:
            // update the state with current mapping
            state = {...state, ...{mapping: action.mapping, mapping_age: action.mapping_age}};
            break;

        case ACTIONS.CHANGE_BASE_COLOR:
            // update the menu color
            state = {...state, ...{menuColor: action.color }};
            break;

        case ACTIONS.CHANGE_BREADCRUMB:
            // update the menu breadcrumb
            state = {...state, ...{breadcrumb: action.breadcrumb}};
            break;
    }

    return state;
};

export default navigationReducer;
